import React from 'react';
import { useState } from 'react';
import { Modal } from 'tea-component';
import { connect, useIntl } from 'umi';
import { GPTType, PromptListType, PromptSimpleConfirmType } from '../types';
import SvgIcon from '@home/components/SvgIcon';
import PromptForm from './PromptForm';
import { getDefaultPromptList } from '../PromptList';
import './index.scss';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';

type GPTPromptType = {
  visible: boolean;
  close: () => void;
  handleConfirm: PromptSimpleConfirmType;
  gameInfo: any;
  wholeGameInfo: any;
  promptList?: PromptListType | ((wholeGameInfo: any) => PromptListType);
  defaultActive?: number;
  defaultPromptText?: string;
  isPreview?: boolean;
  title?: string;
  gptType?: GPTType;
  isAdvanced?: boolean;
};

/**
 * 选择GPT相关配置的浮窗
 * @returns
 */
function PromptModal({
  close,
  visible,
  handleConfirm,
  gameInfo,
  wholeGameInfo,
  promptList = (game) => getDefaultPromptList(game),
  defaultActive = 1,
  defaultPromptText = '',
  isPreview = false,
  title = 'AI Settings',
  gptType,
  isAdvanced = false
}: GPTPromptType) {
  const { formatMessage } = useIntl();
  useRequestFontWebConfig({
    keys: [{ key: 'ai_prompt_list' }],
    gameInfo,
  });

  const [historyVisible, setHistoryVisible] = useState(false);
  const toggleHistoricalPrompt = () => {
    setHistoryVisible(!historyVisible);
  };

  function getModalCaption() {
    if (!historyVisible) return formatMessage({ id: title });
    return (
      <div className="dbo-historical-modal-title">
        <div
          className="dbo-historical-modal-goback"
          onClick={toggleHistoricalPrompt}
        >
          <SvgIcon type="left-pointing" className="dbo-historical-modal-icon" />
          {formatMessage({ id: 'Historical prompt' })}
        </div>
        <div className="dbo-historical-modal-cilck">
          {formatMessage({ id: 'Click to apply' })}
        </div>
      </div>
    );
  }

  return (
    <Modal
      visible={visible}
      caption={getModalCaption()}
      onClose={close}
      size={800}
      destroyOnClose
      className={
        historyVisible ? 'dbo-historical-modal' : 'dbo-aigc-modal-wrapper'
      }
    >
      <PromptForm
        handleConfirm={handleConfirm}
        handleCancel={() => close()}
        promptList={
          typeof promptList === 'function'
            ? promptList(wholeGameInfo)
            : promptList
        }
        gptType={gptType}
        wholeGameInfo={wholeGameInfo}
        historyVisible={historyVisible}
        toggleHistoricalPrompt={toggleHistoricalPrompt}
        defaultActive={defaultActive}
        isPreview={isPreview}
        defaultPromptText={defaultPromptText}
        isAdvanced={isAdvanced}
      ></PromptForm>
    </Modal>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
    gameInfo: opinionCommon.gameInfo,
  };
})(PromptModal);
